import { render } from "./TermsAndConditionsView.vue?vue&type=template&id=9971a084&scoped=true"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=9971a084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9971a084"]])

export default __exports__